import _ from 'lodash';
import { Service } from 'pdk/services';
import http from './http';
import store, { actions } from '@/store';


export class AppService extends Service {
	// CTOR
    constructor(httpService) {
        super();

        this.http = httpService || http;
    }


	// Software updates
    checkForUpdates() {
        return this.http.get('app/version')
            .then((response) => {
                const updatedOn = response.data.updatedOn = new Date(response.data.updatedOn);

                // Update the latest version date
                store.commit(actions.APP_LATEST_VERSION_DATE_SET, {
                    date: updatedOn
                });

                return response.data;
            });
    }
}

export default new AppService();
